module.exports = __webpack_public_path__ + "static/media/processing.caaec026.svg";